define('views/shared/emailverification/emailverification',["backbone",
        "text!views/shared/emailverification/emailverification.html",
        "views/_base/baseview",
        "models/shared/lookups/systext"
], function (Backbone, Template, BaseView, SysText) {
    "use strict";

    return BaseView.extend({
        template:_.template(Template),
        tagName: "section",
        id: "verifyEmailCode",
        isRender: true,
        needsAuth: false,
        initialize: function (options) {
            options = options || {};
            this.IA = sessionStorage.getItem("InvAccount");

            //this.consumerEvents = options.consumerEvents;
            this.resp = options.resp;
            BaseView.prototype.initialize(this);
        },
        isValidEmailVerCode: function (emailVerCode) {
            var pattern = new RegExp(/^\d+$/i);
            return pattern.test(emailVerCode);
        },
        events: {
            "click #verifyBtn": "verify",
            "click #resendBtn": "resendCode"            

        },
        setWatermark: function (itemName, watermarkValue) {
            this.$("[name=" + itemName + "]").watermark(watermarkValue);
        },
        render: function () {
            this.$el.html(this.template());

            this.setWatermark("emailVerCode", "######");

            var that = this;
            this.$el.keydown(function (e) {
                if (e.keyCode == 13) {                   
                    that.verify();
                }
            });

            //var resizeTimer;
            //$(window).resize(function() {
            //    if (resizeTimer) clearTimeout(resizeTimer);
            //    resizeTimer = setTimeout(function() {
            //            pf.popupboxresize(320, 280, null);
            //    }, 300);

            //});
            //window.addEventListener("orientationchange", pf.popupboxresize(320, 280, null), false);

            return this;
        },
        verify: function () {
            var that = this;
            var emailVerCode = that.$("#emailVerCode").val();

            if (that.isValidEmailVerCode(emailVerCode)) {
                if (emailVerCode != null) {
                    var UserVerify = Backbone.Model.extend({
                        url: function () {
                            return pf.userURL + "/" + "Verify";
                        }
                    });

                    $.ajax({
                        type: 'GET',
                        url: pf.url + "/EmailVerification",
                        async: false,
                        contentType: "application/json",
                        data: { EmailGUID:this.resp.U.EG, VerificationCode: emailVerCode },
                        success: function (response,model,resp) {
                            if (resp.status) {
                                pf.session.set({ EmailVerified: true });
                                pf.session.saveToken(that.resp);                                
                                if (pf.IsConsumerFinancial || pf.IsZCardholder || pf.session.get("Verified")) {
                                    pf.navigate("merchants/online");
                                }
                                else {                                    
                                    store.setStoreItem(enums.modelsEnum.EmailVerificationPassed, { Data: 1 });
                                    pf.navigate("wallet");
                                }
                            } else {
                                pfdialog.error({ context: this, Body: "Email Verification Code does not match", Title: "Invalid code" });
                            }
                        },
                        error: function (response) {
                            switch (response.status) {
                                case 400:
                                    var item = that.$("[name=" + "emailVerCode" + "]");
                                    item.addClass("hasError");
                                    $(item).tooltipster();
                                    $(item).tooltipster("content", "Email Verification Code does not match");
                                    $(item).tooltipster("show");
                                    //pfdialog.error({ context: that, Body: "Email Verification Code does not match", Title: "Invalid code" });
                                    break;
                                default:
                                    pfdialog.error({ context: that, Body: "Please try again later", Title: "Internal error" });
                                    break;
                            }
                        }
                    });
                }
            } else {
                var item = this.$("[name=" + "emailVerCode" + "]");
                item.addClass("hasError");
                $(item).tooltipster();
                $(item).tooltipster("content", "Invalid Email Verification Code Format.");
                $(item).tooltipster("show");
            }

        },
        resendCode: function () {
        var that = this;

       // var emailGUID = pf.session.get("EmailGUID");
        var userGUID = this.resp.U.UG;//pf.session.get("UserGUID")
        var url = pf.userURL + "/Email/"+pf.session.get("EmailGUID")+"/SendVerifictionCode";

        $.ajax({
            type: 'GET',            
            url: url,
            contentType: "application/json",                
            success: function (response) {
                //alert("New Code has been sent!");
                pfdialog.thankyou({ Body: "New Code has been sent!", Title: "Success" });

            },
                error: function () {
                    pfdialog.error({ context: that, Body: "Error occurred while tring to resend the code.", Title: "" });
            }
        });

       },
        close: function () { }
    });
});

